import styled from 'styled-components';
import { colors } from 'src/config/colors';

export const StaticPageEditorContent = styled.div`
  grid-area: content;

  a {
    color: ${colors.blue};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colors.blue};
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.875rem;
  }

  ol,
  ul {
    padding-left: 1.25rem;

    &.nested-list-ordered,
    &.nested-list-alpha,
    &.nested-list-number_alpha {
      counter-reset: counter;
      list-style: none;
      position: relative;

      li {
        counter-increment: counter;

        &::before {
          content: counters(counter, '.') ') ';
          left: 0;
          position: absolute;
        }
      }
    }

    ol,
    ul {
      margin-top: 1.25rem;

      li {
        margin-bottom: 0;
      }
    }
  }

  ol {
    li {
      margin-bottom: 1rem;
    }
  }

  ol.nested-list-alpha {
    ol.nested-list-alpha {
      counter-reset: child-counter;

      > li::before {
        content: counter(child-counter, disc);
        counter-increment: child-counter;
      }
    }

    & > li::before {
      content: counters(counter, '.', lower-alpha) ') ';
    }
  }

  ol.nested-list-number_alpha {
    ol.nested-list-number_alpha {
      counter-reset: child-counter;

      > li {
        counter-increment: child-counter;
      }

      > li::before {
        content: counters(child-counter, '.', lower-alpha) '. ';
      }
    }

    & > li::before {
      content: counters(counter, '.') '. ';
    }
  }

  p {
    margin: 0 0 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
